import ProductCard from "@/components/ProductCard";
import { KineticLine, Reveal } from "@/components/Kinetic";

export default function Varsity({ products }) {
  if (!products.length) return null;
  return (
    <section id="varsity" className="relative px-5 sm:px-10 py-28 sm:py-40 border-t border-white/10 overflow-hidden">
      <div className="absolute right-0 top-20 w-[28rem] h-[28rem] neon-glow-pink rounded-full blur-3xl pointer-events-none" aria-hidden="true" />

      <div className="mb-20 sm:mb-28">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#00f0ff] mb-5">Limited — Hand Finished</p>
        </Reveal>
        <h2 className="font-display font-medium uppercase tracking-tighter leading-[0.9] text-5xl sm:text-6xl lg:text-7xl">
          <KineticLine inView>The Varsity</KineticLine>
          <KineticLine inView delay={0.12}>Series</KineticLine>
        </h2>
        <Reveal delay={0.2}>
          <p className="text-sm text-white/50 font-light leading-relaxed max-w-md mt-8">
            Two stadium-grade varsity jackets. One fully sublimated, one hand-airbrushed in a single session —
            no two airbrush jackets are ever identical.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-20 max-w-5xl">
        {products.map((p, i) => (
          <div key={p.lookup_key} className={i === 1 ? "md:mt-32" : ""}>
            <ProductCard product={p} index={i + 8} tall />
          </div>
        ))}
      </div>
    </section>
  );
}
